import styled from 'styled-components';
import Button from 'components/Button/Button';

export const CutReportBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
`;

export const TableWrapper = styled.div`
    @media print {
        padding: 30px;

        .print-hidden {
            display: none !important;
        }
    }
`;

export const PrintButton = styled(Button)`
    @media print {
        display: none !important;
    }
`;

 export const MobileViewNote = styled.p`
    color: gray;
    padding: 8px;
    margin-bottom: 20px;
    border: 1px solid gray;
    background: #f6f6f6;
    @media print {
        display: none !important;
    }
`;

export const LogoWrapper = styled.div`
    max-width: 200px;
    height: 100%;
    width: 100%;
    margin-bottom: 20px;
    display: none;

    @media print {
        display: block !important;
    }
`;